import apiClient from './client'
import API from '@/api/API'
import {
  Transformation,
  CreateTransformationRequest,
  UpdateTransformationRequest,
  ExecuteTransformationRequest,
  ExecuteTransformationResponse,
  DefaultPrompt
} from '@/lib/types/transformations'

export const transformationsApi = {
  list: async () => {
    const response = await apiClient.get<Transformation[]>(API.transformations.base)
    return response.data
  },

  get: async (id: string) => {
    const response = await apiClient.get<Transformation>(`${API.transformations.base}/${id}`)
    return response.data
  },

  create: async (data: CreateTransformationRequest) => {
    const response = await apiClient.post<Transformation>(API.transformations.base, data)
    return response.data
  },

  update: async (id: string, data: UpdateTransformationRequest) => {
    const response = await apiClient.put<Transformation>(`${API.transformations.base}/${id}`, data)
    return response.data
  },

  delete: async (id: string) => {
    await apiClient.delete(`${API.transformations.base}/${id}`)
  },

  execute: async (data: ExecuteTransformationRequest) => {
    const response = await apiClient.post<ExecuteTransformationResponse>(API.transformations.execute, data)
    return response.data
  },

  getDefaultPrompt: async () => {
    const response = await apiClient.get<DefaultPrompt>(API.transformations.defaultPrompt)
    return response.data
  },

  updateDefaultPrompt: async (prompt: { transformation_instructions: string }) => {
    const response = await apiClient.put<DefaultPrompt>(API.transformations.defaultPrompt, prompt)
    return response.data
  }
}